const globalStyles = {
  fonts: {
    primary: "'Poppins'",
    secondary: "'Courier New', Courier, monospace",
    primaryUAE: "AllRoundGothicBold",
    primaryGlobal: "AllRoundGothicBold",
  },
  colors: {
    army_green: "#003A26",
    uclean_gold: "#CD9200",
    uclean_medium_gray: "#666666",
    medium_gray: "#666666",
    text: "#2c3e50",
    border: "#bdc3c7",
    background: "#EEEEEE",
    white: "#ffffff",
    base_light: "#F2F3F0",
    uclean_works: "#D1D1D1",
    uclean_green: "#65BA0D",
    light_gray: "#4F4F4F",
    light_gray1: "#e6ecea",
    light_gray2: "#797979",
    border_gray: "#d9d9d9",
    text_green: "#174C2E",
    uclean_secondary: "#26684D",
    head_green: "#053B26",
  },
  textSizes: {
    small: "12px",
    medium: "16px",
    large: "20px",
    xLarge: "24px",
  },
  fontSizes: {
    h1: "32px",
    h2: "28px",
    h3: "24px",
    h4: "20px",
    h5: "16px",
    h6: "13px",
  },
};

export default globalStyles;
